import useSWR from 'swr'
import API from '../../../utils/api'
import { EXCHANGESETTINGS } from '../../constants/APIKEYS'
import { useToken } from '../auth/token'

let KEY = EXCHANGESETTINGS

let swrData: any = []

export function useExchangeSetting(ep_id: number) {
	KEY = `${EXCHANGESETTINGS}/${ep_id}`
	const { data: token } = useToken()

	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			const response = await API.get(KEY, token + '', {}, false)
			swrData[ep_id] = response.result
			return swrData[ep_id]
		},
		{ revalidateOnFocus: false, dedupingInterval: 1000 * 60, refreshWhenHidden: false }
	)

	return {
		data,
		mutate: (value: any) => {
			if (value !== undefined) swrData[ep_id] = value
			return mutate()
		},
	}
}
